export enum AdvisorUsersRoutePathsEnum {
  ACCOUNTS = '/planner/user/:id/accounts',
  ACTION_PLAN = '/planner/user/:id/action-plan',
  CHAT = '/planner/chat',
  QUESTIONNAIRE = '/planner/user/:id/questionnaire',
  TRANSACTIONS = '/planner/user/:id/transactions',
  USER = '/planner/user/:id',
  USERS = '/planner/users',
}
